<template>
  <div class="dashboard">
    <navbar />

    <b-container fluid>
      <b-row class="py-5">
        <b-col class="text-center" md="6" offset-md="3">
          <img
            class="mb-2"
            height="150"
            src="../assets/logo.png"
            alt="Codingbee logo"
          />
          <h1>Course Completed!</h1>
          <div class="mb-4">
            Well done! Head back to dashboard and check out other online
            activities. If you like to learn more advanced coding courses, be
            sure to check out our offline courses!
          </div>
          <b-button
            class="mr-2"
            to="/dashboard"
            variant="warning"
            size="lg"
            pill
          >
            Back to dashboard
          </b-button>
          <b-button
            class="mr-2"
            href="https://codingbee.my"
            variant="link"
            size="lg"
            pill
          >
            Learn More Advance Coding Skills!
          </b-button>
        </b-col>
      </b-row>
    </b-container>

    <app-footer />
  </div>
</template>

<script>
import { mapState } from "vuex";

import AppFooter from "@/components/AppFooter.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  name: "Dashboard",

  components: {
    Navbar,
    AppFooter
  },

  data() {
    return {
      foundationLevels: [],
      doneActivities: {
        foundation: []
      },
      isLoading: true
    };
  },

  created() {
    this.getLevels();
    this.getUserDoneActivities();
  },

  computed: {
    ...mapState(["user"])
  },

  methods: {}
};
</script>

<style></style>
